import { useState } from "react";
import { FaShare, FaCheck } from "react-icons/fa";
import { triggerSuccessNotification } from "utils/notification";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Notification } from "constant/notifications";

function AnimatedShareButton({ shareUrl }: any) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(shareUrl);
    triggerSuccessNotification(Notification.CopyToClipboard);
    setCopied(true);

    // Reset copied state after a delay
    setTimeout(() => {
      setCopied(false);
    }, 4000);
  };

  return (
    <div>
      <button
        type="button"
        data-tooltip-id="copy-media-link"
        onClick={copyToClipboard}
        className={`flex items-center justify-center gap-2 rounded-full border bg-black/40 px-6 py-3 text-base font-bold transition-all duration-300 ease-in-out max-sm:px-5 max-sm:text-[13px] motion-safe:active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-black ${
          copied
            ? "border-green-500/60 bg-green-500/15 text-green-400 focus-visible:ring-green-500/70"
            : "border-[var(--red)] text-white hover:scale-[1.03] hover:bg-[var(--red)] hover:shadow-lg hover:shadow-[var(--red)]/30 focus-visible:ring-[var(--red)]/70"
        }`}
      >
        {copied ? (
          <>
            <FaCheck
              size={15}
              className="motion-safe:animate-[bounce_0.5s_ease-in-out_1]"
            />
            <span aria-live="polite">Copied</span>
          </>
        ) : (
          <>
            <FaShare size={15} />
            Share
          </>
        )}
      </button>
      <ReactTooltip id="copy-media-link" place="bottom" content="Copy link" />
    </div>
  );
}

export default AnimatedShareButton;